'use strict';

var UserSecureConfig = function UserSecureConfig($httpProvider) {
  $httpProvider.interceptors.push('UserSecureInterceptorFactory');
};
UserSecureConfig.$inject = ['$httpProvider'];
module.exports = UserSecureConfig;